import { onDocumentReady } from '@theme/utilities';

const selector = '[data-bioweapon-normalize]';

function normalizeBioweaponText(root = document) {
  const elements =
    root instanceof Element ? [root, ...root.querySelectorAll(selector)] : document.querySelectorAll(selector);

  for (const element of elements) {
    if (!(element instanceof HTMLElement)) continue;
    if (!getComputedStyle(element).fontFamily.includes('BravoArtBioweaponHeading')) continue;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const nextValue = (node.nodeValue || '').normalize('NFD').replace(/\p{Diacritic}/gu, '');
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
      node = walker.nextNode();
    }
  }
}

onDocumentReady(() => {
  normalizeBioweaponText();

  let rafId = 0;
  const schedule = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      normalizeBioweaponText();
    });
  };

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
});
